import { useContext } from 'react';
import { UserObjectAccessContext } from '../Context';

export const useUserObjectAccess = () => {
  const ctx = useContext(UserObjectAccessContext);

  return ctx;
};

export default useUserObjectAccess;